<template>
  <div class="c-sinfo"
       v-loading="loading"
  >
    <div class="c-sinfo__header">
      <span class="c-sinfo__header_title">  建筑物详情</span>
      <div class="c-sinfo__header_actions">
        <button
          v-if="aqbgWdList.length > 0"
          class="c-btn c-btn--primary"
          @click="handleAqbgClick"
        >
          查看安全报告
        </button>
        <button
          v-if="yjyaWdList.length > 0"
          class="c-btn c-btn--primary"
          @click="handleYjyaClick"
        >
          查看应急预案文件
        </button>
        <button
          v-if="xfwbbgWdList.length > 0"
          class="c-btn c-btn--primary"
          @click="handleXfwbbgClick"
        >
          消防维保报告查看
        </button>
      </div>
    </div>
    <div class="c-sinfo__body">
      <div
        class="c-sinfo__detail"
        :style="{ width: '63%' }"
      >
        <ul class="c-sdt">
          <li class="c-sdt__item">
            <span class="c-sdt__label">建筑物名称：</span>
            <span class="c-sdt__content">{{ jzwInfo.jzwmc }}</span>
          </li>
          <li class="c-sdt__item">
            <span class="c-sdt__label">消防责任单位：</span>
            <span class="c-sdt__content">{{ jzwInfo.sydw }}</span>
          </li>
          <li class="c-sdt__item">
            <span class="c-sdt__label">建筑面积：</span>
            <span class="c-sdt__content">{{ jzwInfo.jzmj }}㎡</span>
          </li>
          <li class="c-sdt__item">
            <span class="c-sdt__label">建筑层数：</span>
            <span class="c-sdt__content">{{ jzwInfo.jzcs }}</span>
          </li>
        </ul>
        <ul class="c-sdt">
          <li class="c-sdt__item">
            <span class="c-sdt__label">消防安全责任人：</span>
            <span class="c-sdt__content">{{ jzwInfo.xfaqzrrmc }}</span>
          </li>
          <li class="c-sdt__item">
            <span class="c-sdt__label">消防安全管理人：</span>
            <span class="c-sdt__content">{{ jzwInfo.xfaqglrmc }}</span>
          </li>
          <li class="c-sdt__item">
            <span class="c-sdt__label">物业区域经理及电话：</span>
            <span class="c-sdt__content">{{ jzwInfo.ldfzr }} {{ jzwInfo.ldfzrdh }}</span>
          </li>
          <li class="c-sdt__item">
            <span class="c-sdt__label">物业区域管理人及电话：</span>
            <span class="c-sdt__content">{{ jzwInfo.dwfzr }} {{ jzwInfo.dwfzrdh }}</span>
          </li>
        </ul>
      </div>
      <div class="c-sb-model">
        <div class="dev-bottom-sp-bg">
          <span class="dev-bottom-sp-bg_title">实时视频</span>
        </div>
        <div class="c-sb-model__inner">
          <easy-video v-if="LWDW_VIDEO=='FALSE'" :video-url="videoUrl" />
          <img
            v-else
            style="width: 100%; height: 100%"
            src="/images/newscreen/bg/jzw-video.jpg"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { monitorService } from '../monitor.service';
// import videoView from '../../video/video-view2.vue';
// import videoHls from '../../video/video-hls.vue';
import EasyVideo from '@/features/video/video-flv.vue';
import config from '@/config.js';
import { getEnvInfo } from '@/features/feature.common.service';

export default {
  name: 'BottomBox',
  components: {
    // videoView
    // videoHls,
    EasyVideo
  },
  props: {
    activeMonitoringRoom: {
      type: String,
      default: null
    },
    activeJzw: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      // 建筑物概述信息
      loading: false, // 页面loading状态
      jzwInfo: {},
      sbList: [],
      wdList: [],
      initDownloadApi: this.$config.fileApi.initDownload,
      downloadApi: this.$config.fileApi.download,
      videoUrl: '', // 视频播放地址
      vimage: '/assets/video.png', // 视频封面地址
      LWDW_VIDEO: 'TRUE'
    };
  },
  computed: {
    currentUser () {
      return this.$HMStoreService.getUserinfo();
    },
    yjyaWdList () {
      return this.wdList.filter(item => {
        return item.wdType === 'YJYA';
      });
    },
    aqbgWdList () {
      return this.wdList.filter(item => {
        return item.wdType === 'AQBG';
      });
    },
    xfwbbgWdList () {
      return this.wdList.filter(item => {
        return item.wdType === 'XFWBBG';
      });
    },
  },
  methods: {
    initDownload (fileId) {
      return this.$axios.get(`${this.initDownloadApi}/${fileId}`);
    },
    async handleYjyaClick () {
      this.loading = true;
      if (!this.yjyaWdList || this.yjyaWdList.length === 0 || !this.yjyaWdList[0].path) {
        console.error('没有应急预案文件！');
        return;
      }
      await this.initDownload(this.yjyaWdList[0].path).then(async rsp => {
        const filePath = rsp.data.data;
        await this.$axios.get(`${this.downloadApi}/${filePath}`, {
          responseType: 'blob' // 重要：指定响应类型为blob
        }).then((res) => {
          const fileBlob = new Blob([res.data], { type: 'application/pdf' });
          const fileUrl = URL.createObjectURL(fileBlob);
          // 弹框展示PDF
           this.openPdfDialog(fileUrl, '应急预案');
        }).catch((err) => {
          console.error('下载文件失败！', err);
        });
      });
      this.loading = false;
    },
    async handleXfwbbgClick () {
      this.loading = true;
      if (!this.xfwbbgWdList || this.xfwbbgWdList.length === 0 || !this.xfwbbgWdList[0].path) {
        console.error('没有消防维保报告文件！');
        return;
      }
      await this.initDownload(this.xfwbbgWdList[0].path).then( async  rsp => {
        const filePath = rsp.data.data;
        await this.$axios.get(`${this.downloadApi}/${filePath}`, {
          responseType: 'blob' // 重要：指定响应类型为blob
        }).then((res) => {
          const fileBlob = new Blob([res.data], { type: 'application/pdf' });
          const fileUrl = URL.createObjectURL(fileBlob);
          // 弹框展示PDF
          this.openPdfDialog(fileUrl, '应急预案');
        }).catch((err) => {
          console.error('下载文件失败！', err);
        });
      });
      this.loading = false;
    },
    async handleAqbgClick () {
      this.loading = true;
      if (!this.aqbgWdList || this.aqbgWdList.length === 0 || !this.aqbgWdList[0].path) {
        console.error('没有安全报告文件！');
        return;
      }
      await this.initDownload(this.aqbgWdList[0].path).then(async rsp => {
        const filePath = rsp.data.data;
        await this.$axios.get(`${this.downloadApi}/${filePath}`, {
          responseType: 'blob' // 重要：指定响应类型为blob
        }).then((res) => {
          const fileBlob = new Blob([res.data], { type: 'application/pdf' });
          const fileUrl = URL.createObjectURL(fileBlob);
          // 弹框展示PDF
          this.openPdfDialog(fileUrl, '安全报告');
        }).catch((err) => {
          console.error('下载文件失败！', err);
        });
      });
      this.loading = false;
    },
    // 打开PDF对话框
    async openPdfDialog (pdfUrl, title) {
      // 创建一个对话框元素
      const dialog = document.createElement('div');
      dialog.style.position = 'fixed';
      dialog.style.top = '0';
      dialog.style.left = '0';
      dialog.style.width = '100%';
      dialog.style.height = '100%';
      dialog.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
      dialog.style.zIndex = '9999';
      dialog.style.display = 'flex';
      dialog.style.flexDirection = 'column';
      dialog.style.alignItems = 'center';
      // 创建标题栏
      const titleBar = document.createElement('div');
      titleBar.style.width = '80%';
      titleBar.style.padding = '10px';
      titleBar.style.backgroundColor = '#044c8a';
      titleBar.style.color = 'white';
      titleBar.style.display = 'flex';
      titleBar.style.justifyContent = 'space-between';
      titleBar.style.borderTopLeftRadius = '5px';
      titleBar.style.borderTopRightRadius = '5px';
      titleBar.style.marginTop = '30px';
      // 创建标题
      const titleElement = document.createElement('span');
      titleElement.innerText = title || 'PDF预览';
      titleBar.appendChild(titleElement);
      // 创建关闭按钮
      const closeButton = document.createElement('button');
      closeButton.innerText = '关闭';
      closeButton.style.backgroundColor = '#0093ff';
      closeButton.style.border = 'none';
      closeButton.style.color = 'white';
      closeButton.style.padding = '4px 12px';
      closeButton.style.borderRadius = '4px';
      closeButton.style.cursor = 'pointer';
      closeButton.onclick = function () {
        document.body.removeChild(dialog);
        URL.revokeObjectURL(pdfUrl); // 释放URL
      };
      titleBar.appendChild(closeButton);
      // 创建PDF嵌入元素
      const embed = document.createElement('embed');
      embed.src = pdfUrl;
      embed.type = 'application/pdf';
      embed.style.width = '80%';
      embed.style.height = 'calc(100% - 130px)';
      embed.style.backgroundColor = 'white';
      // 将元素添加到对话框
      dialog.appendChild(titleBar);
      dialog.appendChild(embed);
      // 将对话框添加到文档
      document.body.appendChild(dialog);
    },
    queryJzw () {
      monitorService.queryJzw(this.activeMonitoringRoom, this.activeJzw)
        .then(rsp => {
          this.jzwInfo = rsp.data;
        })
        .catch(err => {
          console.error('获取建筑物信息错误！', err);
        });
    },
    initVideoUrl () {
      const _this = this;
      // 组装url地址
      const hasToken = this.$HMCookies.get(config.localTokenName) || false;
      // 获取播放地址
      monitorService.listSbByJzwId(_this.activeJzw).then(rsp => {
        console.log('获取视频列表', rsp.data);
        _this.sbList = rsp.data;
        if (_this.sbList.length > 0) {
          _this.videoUrl = _this.sbList[0].flvVideoUrl + '?time=' + new Date().getTime() + '&token=' + hasToken;
        } else {
          _this.videoUrl = '';
        }
        // 演示使用公司楼下消控室摄像头
        _this.videoUrl = 'https://iff-live.hongmeng.cloud/2c9d809b8c67f924018c6c8383ad0164/001.live.flv' + '?time=' + new Date().getTime() + '&token=' + hasToken;
      });
    },
    getWdInfo () {
      const param = {
        ssdw: this.activeMonitoringRoom,
        jzwId: this.activeJzw
      };
      monitorService.queryWdAndWbbg(param).then(resp => {
        this.wdList = resp.data.rows;
        console.log('获取文档信息', this.wdList);
      });
    },
    getEnvInfo () {
      const ssdw = this.currentUser.capacity.deptCode;
      getEnvInfo(ssdw, 'LWDW_VIDEO')
        .then(resp => {
          this.LWDW_VIDEO = resp.data.envValue;
          console.log('获取联网单位LWDW_VIDEO', this.LWDW_VIDEO);
        });
    }
  },
  watch: {
    activeMonitoringRoom (newVal, oldVal) {
      if (this.activeMonitoringRoom) {
        this.queryJzw();
      }
    },
    activeJzw (newVal, oldVal) {
      this.queryJzw();
      this.initVideoUrl();
      this.getWdInfo();
    }
  },
  created () {
    this.queryJzw();
    // const videoProtocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
    // this.videoUrl = `${rtspApi || window.location.host}/test/live`;
    this.getEnvInfo();
    this.initVideoUrl();
    this.getWdInfo();
  }
};
</script>

<style scoped lang="scss">
@import '../../virtual/chart/chart.scss';

.c-sinfo{
  background: url('/images/newscreen/bg/实时报警.png') no-repeat center;
  background-size: 100% 100%;

  &__header{
    display: flex;
    align-items: center;
    position: relative;
    top: 23px;
    left: 10px;
    width: 97%;
    height: 30px;
    background: url('/images/newscreen/bg/实时报警标题.png');
    background-size: contain;
    background-repeat: no-repeat;

    &_title{
      margin-top: -7px;
      margin-left: 25px;
      font-family: HYYaKuHei-85J;
      font-weight: 85J;
      font-size: 16px;
      color: #FFFFFF;
    }

    &_actions {
      display: flex;
      gap: 10px;
      margin-left: 10px;
      padding-bottom: 5px;
    }
  }

  &__body{
    display: flex;
    width: 100%;
    padding: 30px 20px 0 20px;
  }
}

// 按钮样式
.c-btn {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  border: none;
  transition: all 0.3s;

  &--primary {
    background-color: #0093ff;
    color: white;

    &:hover {
      background-color: #007fd6;
    }
  }

  &--secondary {
    background-color: #044c8a;
    color: white;

    &:hover {
      background-color: #033c6e;
    }
  }
}

.u-sub_title{
  display: block;
  width: 182px;
  height: 20px;
  padding-left: 4px;
  margin-bottom: 12px;
  border-left: 4px solid #10B6FF;
  font-size: 14px;
  line-height: 20px;
  background-image: linear-gradient(270deg, rgba(0,0,0,0.00) 0%, rgba(0,152,255,0.45) 100%);
}

.c-sb-model{
  width: 30%;
}

.c-sb-model__inner{
  width: 358.39px;
  height: 186px;
  padding: 1px;
  margin-top: 4px;
  border: 1px solid rgba(16,182,255,1);
  background: url('/monitor/images/hj/hz_mr.png');
  background-size: 100% 100%;
  border-radius: 8px;

  img{
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
  }
}

.c-sinfo__detail{
  margin-top: 20px;
  display: flex;
  width: 63%;

  .c-sdt{
    width: 49%;

    &__item {
      align-items: center;
      justify-content: flex-start;

      &:nth-child(2n-1){
        height: 36px;
        background: #044c8a4d;
      }
    }

    &__label{
      flex-shrink: 0;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      font-weight: 400;
      color: #E2F3FF;

      &::before{
        content: '';
        display: inline-block;
        position: relative;
        top: 3px;
        width: 21px;
        height: 15px;
        margin-right: 8px;
        background: url('/monitor/images/tj/bottom-jz.png');
      }
    }

    &:last-child .c-sdt__label{
      flex-shrink: 0;

    }

    &__content{
      padding-left: 16px;
      font-family: AlibabaPuHuiTi_2_55_Regular;
      font-size: 14px;
      font-weight: 400;
      color: #00CEFF;
    }
  }
}

.dev-bottom-sp-bg{
  width: 358px;
  height: 24px;
  text-align: center;
  background: url('/monitor/images/tj/bottom-sxt.png');

  &_title{
    font-family: AlibabaPuHuiTi_2_85_Bold;
    font-size: 14px;
    font-weight: 700;
    line-height: 1px;
    color: #FFF;
    text-align: center;
    text-shadow: 0 2px 4px #0000004d;
  }
}

</style>
